import FrontPage from '@/components/pages/frontpage/front-page-controller';
import getStaticProps from '@/components/pages/frontpage/front-page-static-props';

export default FrontPage;
export { getStaticProps };
